import { User } from '../../lib/classes/user';
import { Role, Unit } from './unit';

export class UnitEmployment {
  id: number;
  role: Role;
  user: User;
  unit: Unit;
  has_accepted_invitation: boolean;
  has_seen_intro: boolean;
}

export const ALLROLES = [
  { value: 1, viewValue: 'Admin' },
  { value: 2, viewValue: 'Recruiter' },
  { value: 3, viewValue: 'Viewer' },
];
